import { useMemo } from 'react'

export function useUSDValue(amount: string | undefined, price: number | null | undefined): string | undefined {
  return useMemo(() => {
    if (!amount || !price) return undefined
    const numAmount = parseFloat(amount)
    if (isNaN(numAmount)) return undefined
    return (price * numAmount).toString()
  }, [amount, price])
}
